module.exports = __webpack_public_path__ + "static/img/p2.27f0324.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p2.png
// module id = hSXY
// module chunks = 1